import { useSelector } from 'react-redux'
import { OptimizationMode } from '../../../../../../../types/Survey/Analysis/Concept'
import Button from '../../../../../../UI/Button/Button'
import props from '../../../../../../../redux/props'

type Props = {
  value: OptimizationMode
  onChange: (value: OptimizationMode) => void
}

const OptimizationModeSelection: React.FC<Props> = ({ value, onChange }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <div className="flex gap-5 items-center justify-between">
      <div className="font-light text-md text-nowrap">{t.survey.analysis.concept.optimization.mode.title}</div>
      <div className="w-1/2 flex items-center gap-3 justify-end">
        {[OptimizationMode.STANDARD, OptimizationMode.MIN, OptimizationMode.MAX].map((mode) => (
          <Button contrast={value === mode} onClick={() => onChange(mode)} text={t.survey.analysis.concept.optimization.mode[mode]} key={mode} />
        ))}
      </div>
    </div>
  )
}

export default OptimizationModeSelection
